import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var ArchiveIcon32Regular = forwardRefAndName('ArchiveIcon32Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 32
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M14.75 6C14.1977 6 13.75 6.44772 13.75 7C13.75 7.55228 14.1977 8 14.75 8H16.25C16.8023 8 17.25 7.55228 17.25 7C17.25 6.44772 16.8023 6 16.25 6H14.75Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M11.75 9C11.75 8.44771 12.1977 8 12.75 8H14.25C14.8023 8 15.25 8.44771 15.25 9C15.25 9.55229 14.8023 10 14.25 10H12.75C12.1977 10 11.75 9.55229 11.75 9Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M14.75 10C14.1977 10 13.75 10.4477 13.75 11C13.75 11.5523 14.1977 12 14.75 12H16.25C16.8023 12 17.25 11.5523 17.25 11C17.25 10.4477 16.8023 10 16.25 10H14.75Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M11.75 13C11.75 12.4477 12.1977 12 12.75 12H14.25C14.8023 12 15.25 12.4477 15.25 13C15.25 13.5523 14.8023 14 14.25 14H12.75C12.1977 14 11.75 13.5523 11.75 13Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M18 20.5673C18 22.3412 16.4242 24 14.4912 24C12.5582 24 11 22.3412 11 20.5673C11 19.1999 12.2186 16.6325 12.7771 15.5276C12.9428 15.1999 13.2797 15 13.647 15H15.3008C15.6862 15 16.0367 15.2204 16.1973 15.5707C16.7557 16.7887 18 19.6101 18 20.5673ZM16.1249 20.6251C16.1249 21.5225 15.3974 22.2501 14.4999 22.2501C13.6024 22.2501 12.8749 21.5225 12.8749 20.6251C12.8749 19.7276 13.6024 19.0001 14.4999 19.0001C15.3974 19.0001 16.1249 19.7276 16.1249 20.6251Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M5 7.5C5 4.46243 7.46243 2 10.5 2H21.5C24.5376 2 27 4.46243 27 7.5V24.5C27 27.5376 24.5376 30 21.5 30H10.5C7.46243 30 5 27.5376 5 24.5V7.5ZM10.5 4C8.567 4 7 5.567 7 7.5V24.5C7 26.433 8.567 28 10.5 28H21.5C23.433 28 25 26.433 25 24.5V7.5C25 5.567 23.433 4 21.5 4H14.25C14.8023 4 15.25 4.44772 15.25 5C15.25 5.55228 14.8023 6 14.25 6H12.75C12.1977 6 11.75 5.55228 11.75 5C11.75 4.44772 12.1977 4 12.75 4H10.5Z"
    }))
  );
});